var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('rc-sheets',{ref:"sheetsTable",staticClass:"client-sheets mt-2",attrs:{"showAll":"","paginate":"","clickToVisit":"","sheets":_vm.sheets,"metadata":_vm.metadata,"loading":_vm.loading},on:{"recall":_vm.getSheets}})}
var staticRenderFns = []

export { render, staticRenderFns }